<dl-chart-table
	class="chart-table"
	[tableDataTab]="tableDataTab"
	[chartDataTabs]="chartDataTabs"
	[columnClassOverride]="columnClassOverride"
	[tableClassOverride]="'col-10'"
	[chartClassOverride]="'col-14'"
	[chartConfig]="[returnChartConfig, riskChartConfig]"
	[colors]="seriesColours"
	[portfolioCount]="chartData?.portfolioData?.length"
	[toggleBreakpoint]="3"
	[chartHeight]="chartHeight"
	[hideChart]="hideChart"
	[tableOptions]="tableOptions"
></dl-chart-table>
